export const WATER_DISTRIBUTION_NETWORK_TYPES = {
  WTP: 'Water treatment plant',
  ESR: 'Elevated storage reservoir',
  PDN: 'Pipe distribution network',
  GWI: 'Grey water infrastructure',
};
